const state = () => ({
	city: {} as any,
});

export default state;
